// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__224AL","info":"UpdateTermsInfo_info__3TE8M"};